import { render, staticRenderFns } from "./LootAlarm.vue?vue&type=template&id=2953fa6b&scoped=true"
import script from "./LootAlarm.vue?vue&type=script&lang=js"
export * from "./LootAlarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2953fa6b",
  null
  
)

export default component.exports